import { Injectable } from '@angular/core';
import {firstValueFrom, Observable, ReplaySubject} from "rxjs";
import {filter, map, take, tap} from "rxjs/operators";
import {ContractControlService} from "../../contract-control.service";
import { IPageableResponse } from 'app/global/pagging.dto';
import { IGetContractControlDataResponse } from '../../store/dto/contract-control-view';

export interface IContractCardItem{
    id: number;
    name:string;
}

@Injectable({
  providedIn: 'root'
})
export class ContractCardItemsService {

    private _contractCard$: ReplaySubject<IContractCardItem[]> = new ReplaySubject(1);
    contractCard$:Observable<IContractCardItem[]> = this._contractCard$.asObservable();

  constructor(private contractControlService: ContractControlService) {
     this.refreshContractCard();
  }

  public refreshContractCard():Promise<IContractCardItem[]>{
   return firstValueFrom(
    this.contractControlService.fetchContracts(1, '')
    .pipe(
        map(x => (x as IPageableResponse<IGetContractControlDataResponse>)?.data?.map(y => ({
            id: y.id,
            name: y.contract_control_name
        } as IContractCardItem)) ?? []),
        tap(x=>{
            this._contractCard$.next(x ?? []);
        })))
  }

  makeAContractControlSearch(text: string):void{
      this.contractControlService.fetchContracts(1, text)
          .pipe(
              filter(Boolean),
              take(1)
          )
          .subscribe(x=> this._contractCard$.next( (x).data.map((y)=> ({
              id:y.id,
              name:y.contract_control_name
          }))));
  }

}
